/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-11-26 16:30:24
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-04-16 19:39:21
 * @Description: file content
 * 通用工具类
 * 特点：
 * 1、纯前端操作，不能牵扯ajax
 */
import jsCookie from "js-cookie";

import moment from 'moment'//导入文件
moment.locale('zh-cn');//需要汉化

import md5 from 'js-md5';

export default {
  cookie: jsCookie,
  moment: moment,
  md5: md5,
  browser: {
    info: navigator.appVersion,
    versions: (function () {
      let u = navigator.userAgent;
      return {
        trident: u.indexOf("Trident") > -1,
        presto: u.indexOf("Presto") > -1,
        webKit: u.indexOf("AppleWebKit") > -1,
        gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1,
        mobile: !!u.match(/AppleWebKit.*Mobile.*/) || !!u.match(/AppleWebKit/),
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
        android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1,
        iPhone: u.indexOf("iPhone") > -1 || u.indexOf("Mac") > -1,
        iPad: u.indexOf("iPad") > -1,
        webApp: u.indexOf("Safari") == -1,
        wx: u.toLowerCase().match(/MicroMessenger/i) == "micromessenger"
      };
    })()
  },
  randomCutArray(arr, selectedCount) {
    let result = [];
    let count = arr.length;
    for (let i = 0; i < selectedCount; i++) {
      let index = ~~(Math.random() * count) + i;
      result[i] = arr[index];
      arr[index] = arr[i];
      count--;
    }
    return result;
  },
  randomArray(arr) {
    return arr.sort(() => {
      return Math.random() > .5 ? -1 : 1;
    });
  },
  getRandomNum(maxNum) {
    return Math.floor(Math.random() * (maxNum + 1));
  },
  // 验证手机号码合法性
  isMobile: function (mobile) {
    return /^1+\d{10}$/.test(String(mobile).replace(/^0+/g, ""));
  },
  getViewSize() {
    return {
      width: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
      height: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
    };
  },
  getObjFromObjArrayByProp(filterObj, objList) {
    let tmpObj = null;
    for (let index = 0; index < objList.length; index++) {
      let isPropEqual = true;
      Object.keys(filterObj).forEach(k => {
        if (filterObj[k] != objList[index][k]) {
          isPropEqual = false;
        }
      })
      if (isPropEqual) {
        tmpObj = objList[index];
      }
    }
    return tmpObj;
  },
  /**
  * 计算字符串长度(英文占1个字符，中文汉字占2个字符)
  * @param {*} str 
  */
  getStrBlen(str) {
    let len = 0;
    for (let i = 0; i < str.length; i++) {
      if (str.charCodeAt(i) > 127 || str.charCodeAt(i) == 94) {
        len += 2;
      } else {
        len++;
      }
    }
    return len;
  },
  /**
   * 拨打电话
   */
  makePhoneCall(phone) {
    window.location.href = "tel:" + phone;
  },
  redirectTo(url) {
    window.location.href = url;
  },
  /**
   * obj 
   * abc: {
        efg: {
          hij: "hijvale"
        }
      }
   */
  findKeyByStrValueInObj(obj, val) {
    let result = "";
    Object.keys(obj).forEach(k => {
      if (obj[k] == val) {
        result = k;
        return false;
      } else if (typeof obj[k] == "object") {
        let result1 = this.findKeyByStrValueInObj(obj[k], val);
        if (result1) {
          result += k + "." + result1;
        }
      }
    });
    return result;
  },
  /**
   * 用户摇动手机 需要https
   * @param {*} fn 回调函数
   */
  shake(fn) {
    return new Promise((resolve) => {
      const shake = 3000;
      let last_update = 0;
      let x = 0;
      let y = 0;
      let z = 0;
      let last_x = 0;
      let last_y = 0;
      let last_z = 0;
      const deviceMotionHandler = (eventData) => {
        const acceleration = eventData.accelerationIncludingGravity;
        const currTime = new Date().valueOf();
        const diffTime = currTime - last_update;
        if (diffTime > 100) {
          last_update = currTime;
          x = acceleration.x;
          y = acceleration.y;
          z = acceleration.z;
          const speed = Math.abs(x + y + z - last_x - last_y - last_z) / diffTime * 20000
          if (speed > shake) {
            fn()
          }
          last_x = x;
          last_y = y;
          last_z = z;
        }
      }

      if (window.DeviceMotionEvent) {
        window.addEventListener('devicemotion', deviceMotionHandler, false);
        resolve(true);
      } else {
        console.log("本设备不支持devicemotion事件");
        resolve(false);
      }
    })
  },
  windowScroll(callback) {
    window.addEventListener("scroll", callback, true);
  },
  getGuid() {
    let tmpGuid = "";
    for (var i = 1; i <= 32; i++) {
      var n = Math.floor(Math.random() * 16.0).toString(16);
      tmpGuid += n;
      if ((i == 8) || (i == 12) || (i == 16) || (i == 20))
        tmpGuid += "";
    }
    return tmpGuid;
  }
}